import React, {useEffect, useLayoutEffect, useState} from 'react';
import {Tabs} from 'antd';
import './ViewKeyRiskIndicator.scss';
import {t} from 'react-switch-lang';
import SelectList from '../../../components/FormFields/Select';
import TextArea from '../../../components/FormFields/Textarea';
import InputText from '../../../components/FormFields/InputText';
import InputYear from '../../../components/FormFields/inputDate/InputYear';
import {
  getAllDepartments,
  getAllProcesses,
  getAllSubProcesses,
  getKeyRisk,
  updateKeyRisk,
  deleteKeyRisk,
  deleteKeyRiskOccurrence,
  getCountAllDepartments,
} from '../../../services/keyRiskIndicatorsService';
import {getLanguage} from 'react-switch-lang';
import * as yup from 'yup';
import '../addKeyRiskIndicator/AddKeyRiskIndicator.scss';
import {useHistory} from 'react-router-dom';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import Toast from '../../../components/toast/Toast';
import {useUserContext} from '../../../contexts/UserContext';
import Prompt from '../../../components/prompt/prompt';
import CustomTable from '../../../components/customTable/CustomTable';
import {ReactComponent as OptionsImg} from '../img/options.svg';
import Dropdown from '../../../components/droppdown/dropdown';
import OccurrenceModal from './riskOccurrenceModal/OccurrenceModal';
import {formatDate} from '../../../utils/formatDate';
import periods from '../utils/periods';
import roles from '../../../utils/roles';
import Swal from 'sweetalert2';
import {useDepartmentContext} from '../../../contexts/DepartmentContext';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import {Col} from 'react-bootstrap';

const {TabPane} = Tabs;

const ViewKeyRiskIndicator = (props) => {
  const lang = getLanguage();

  const [keyRisk, setKeyRisk] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [subProcesses, setSubProcesses] = useState([]);
  const [departments, setDepartments] = useState([]);

  let history = useHistory();

  const [isEditing, setIsEditing] = useState(false);

  const userAuthorities = useUserContext().authorities;
  const userDepartments = useDepartmentContext();

  const userSuperAdmin = userAuthorities.some((r) =>
    r.includes(roles.role_super_admin)
  );
  const userRiskSector = userAuthorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );
  const userResponsible = userAuthorities.some((r) =>
    r.includes(roles.role_responsible_user)
  );
  const userInCharge = userAuthorities.some((r) =>
    r.includes(roles.role_user_in_charge)
  );

  const [departmentUserInCharge, setDepartmentUserInCharge] = useState(false);
  const [departmentUserResponsible, setDepartmentUserResponsible] = useState(
    false
  );

  const [disableSubprocess, setDisableSubprocess] = useState(true);

  const [countDepartment, setCountDepartment] = useState();

  const fetchProcesses = async () => {
    try {
      const {data} = await getAllProcesses();
      setProcesses(data);
      return data;
    } catch (e) {}
  };

  /*** Fetch after process selected in form ***/
  const fetchSubprocesses = async () => {
    try {
      const {data} = await getAllSubProcesses(watchProcess['value']);
      setSubProcesses(data);
      return data;
    } catch (e) {}
  };

  // const fetchCountDepartments = async () => {
  //   try {
  //     const {data} = await getCountAllDepartments();
  //     setCountDepartment(data);
  //     return data;
  //   } catch (e) {}
  // };

  // const fetchDepartments = async () => {
  //   try {
  //     const {data} = await getAllDepartments();
  //     setDepartments(data);
  //     return data;
  //   } catch (e) {}
  // };

  const schema = yup.object().shape({
    process: yup.object().nullable().required(t('message.fieldRequired')),
    subprocess: yup.object().nullable().required(t('message.fieldRequired')),
    subprocessDescriptionMne: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(255, t('message.max', {max: 255})),
    subprocessDescriptionEn: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(255, t('message.max', {max: 255})),
    riskIndicatorNameMne: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(500, t('message.max', {max: 500})),
    riskIndicatorNameEn: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(500, t('message.max', {max: 500})),
    escalationPointValue: yup
      .string()
      .nullable()
      .required(t('message.fieldRequired'))
      .max(4, t('message.max', {max: 4})),
    period: yup.object().nullable().required(t('message.fieldRequired')),
    escalationDescription: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(500, t('message.max', {max: 500})),
    department: yup.object().nullable().required(t('message.fieldRequired')),
    riskDescriptionMne: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(500, t('message.max', {max: 500})),
    riskDescriptionEn: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(500, t('message.max', {max: 500})),
    measuresDescriptionMne: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(500, t('message.max', {max: 500})),
    measuresDescriptionEn: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(500, t('message.max', {max: 500})),
    year: yup.string().nullable().required(t('message.fieldRequired')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, reset, setValue} = methods;
  const watchProcess = watch('process');

  useEffect(() => {
    const fetchKeyRisk = async () => {
      try {
        const {data} = await getKeyRisk(props.match.params.id);
        if (userInCharge) {
          userDepartments.forEach((department) => {
            if (data.departmentId === department.id) {
              setDepartmentUserInCharge(true);
            }
          });
        }

        if (userResponsible) {
          userDepartments.forEach((department) => {
            if (data.departmentId === department.id) {
              setDepartmentUserResponsible(true);
            }
          });
        }
        let selectedPeriod = {};
        for (let period of periods) {
          if (period.value === data.indicatorPeriod) {
            selectedPeriod = period;
          }
        }
        setKeyRisk({
          process: {
            label: lang === 'eng' ? data.processNameEn : data.processName,
            value: data.processId,
          },
          subprocess: {
            label: lang === 'eng' ? data.subprocessNameEn : data.subprocessName,
            value: data.subprocessId,
          },
          department: {
            label: lang === 'eng' ? data.departmentNameEn : data.departmentName,
            value: data.departmentId,
          },
          riskIndicatorNameMne: data.indicatorName,
          riskIndicatorNameEn: data.indicatorNameEn,
          subprocessDescriptionMne: data.subprocessDescription,
          subprocessDescriptionEn: data.subprocessDescriptionEn,
          description: data.description,
          indicatorName: data.riskIndicatorName,
          indicatorNameEn: data.riskIndicatorNameEn,
          indicatorPeriod: selectedPeriod,
          measuresDescription: data.measures,
          measuresDescriptionEn: data.measuresEn,
          minValue: data.minValue,
          riskDescription: data.riskDescription,
          riskDescriptionEn: data.riskDescriptionEn,
          year: data.year,
        });
      } catch (err) {
        if (
          err.response.data.status === 403 ||
          err.response.data.status === 404
        ) {
          history.push('/key-risk-indicators');
        }
      }
    };
    fetchKeyRisk().then(() => {
      fetchProcesses().then((r) => {
        let processes = [];
        r.forEach((item) => {
          processes.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });

        setProcesses(processes);
      });
    });

    // fetchCountDepartments().then((r) => {
    //   const fetchDepartments = async () => {
    //     try {
    //       const {data} = await getAllDepartments(r);
    //       setDepartments(data);
    //       return data;
    //     } catch (e) {}
    //   };
    //   fetchDepartments().then((r) => {
    //     let departments = [];
    //     r.forEach((item) => {
    //       departments.push(
    //         lang === 'eng'
    //           ? {value: item.id, label: item.nameEn}
    //           : {
    //               value: item.id,
    //               label: item.name,
    //             }
    //       );
    //     });

    //     setDepartments(departments);
    //   });
    // });
  }, []);

  useEffect(() => {
    if (window.location.pathname.includes('edit')) {
      setDisableSubprocess(false);
    }
    window.location.pathname.includes('edit')
      ? setIsEditing(true)
      : setIsEditing(false);
  }, []);

  const [renderAfter, setRenderAfter] = useState(0);
  useEffect(() => {
    /*** Get subprocesses on process change ***/
    setRenderAfter(renderAfter + 1);
    if (watchProcess) {
      if (renderAfter >= 3) {
        fetchSubprocesses().then((r) => {
          let subProcesses = [];
          r.forEach((item) => {
            subProcesses.push(
              lang === 'eng'
                ? {value: item.id, label: item.nameEn}
                : {
                    value: item.id,
                    label: item.name,
                  }
            );
          });
          setSubProcesses(subProcesses);
        });
        setValue('subprocess', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
      }
    }
    /*** If process cleared, clear subprocess ***/
    if (watchProcess === null) {
      setValue('subprocess', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchProcess]);

  const goToAdd = () => {
    history.push({
      pathname: '/key-risk-indicators/add',
      state: {keyRisk: keyRisk},
    });
  };

  const onSubmit = async (e) => {
    const date = new Date(e.year);
    const year = date.getFullYear();
    const body = {
      id: props.match.params.id,
      departmentId: e.department['value'],
      departmentName: lang === 'mne' ? e.department['label'] : '',
      departmentNameEn: lang === 'eng' ? e.department['label'] : '',
      description: e.escalationDescription,
      indicatorName: e.riskIndicatorNameMne,
      indicatorNameEn: e.riskIndicatorNameEn,
      indicatorPeriod: e.period['value'],
      measures: e.measuresDescriptionMne,
      measuresEn: e.measuresDescriptionEn,
      minValue: e.escalationPointValue,
      processId: e.process['value'],
      processName: lang === 'mne' ? e.process['label'] : '',
      processNameEn: lang === 'eng' ? e.process['label'] : '',
      riskDescription: e.riskDescriptionMne,
      riskDescriptionEn: e.riskDescriptionEn,
      subprocessDescription: e.subprocessDescriptionMne,
      subprocessDescriptionEn: e.subprocessDescriptionEn,
      subprocessId: e.subprocess['value'],
      subprocessName: lang === 'mne' ? e.subprocess['label'] : '',
      subprocessNameEn: lang === 'eng' ? e.subprocess['label'] : '',
      year: year,
    };
    try {
      const response = await updateKeyRisk(body);
      if (response.status === 200) {
        await Toast.fire({
          title: t('Pages.messages.updateSuccess', {
            entity: t('Pages.common.keyRiskIndicator'),
          }),
          icon: 'success',
        });
        window.location = `/key-risk-indicators/${parseInt(response.data.id)}`;
      }
    } catch (err) {
      if (err.response.data.code === 'indicator-exists') {
        Toast.fire({
          title:
            lang === 'eng'
              ? err.response.data.description
              : t('Pages.messages.sameIndicatorAdded'),
          icon: 'error',
        });
        document.getElementById('riskIndicatorNameMne').focus();
        document.getElementById('riskIndicatorNameMne').select();
      } else {
        reset();
        setValue('process', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('subprocess', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('department', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('period', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('year', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        Swal.fire({
          text: t('Pages.messages.addError', {
            entity: lang === 'eng' ? 'key risk' : 'ključnog rizika',
          }),
          icon: 'error',
        });
      }
    }
  };

  const onDeleteKeyRisk = () => {
    const dropdown = document.getElementById('dropdown');
    const dropdownUl = document.getElementsByClassName('show')[1];
    dropdown.style.display = 'none';
    dropdownUl.style.display = 'none';

    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteKeyRisk'),
        text: t('question.delete', {
          entity: t('Pages.common.keyRiskIndicator2'),
        }),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        onClose: () => {
          dropdown.style.display = 'block';
          dropdownUl.style.display = 'block';
        },
        preConfirm: async () => {
          dropdown.style.display = 'block';
          dropdownUl.style.display = 'block';
          try {
            const response = await deleteKeyRisk(props.match.params.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('Pages.messages.deleteSuccess', {
                  entity: t('Pages.common.keyRiskIndicator'),
                }),
                icon: 'success',
              });
              resolve(response);
              history.push({
                pathname: '/key-risk-indicators',
              });
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError', {
                entity:
                  lang === 'eng'
                    ? t('Pages.common.keyRiskIndicator2')
                    : t('Pages.common.keyRiskIndicator3'),
              }),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  /*** Second Tab ***/
  const columns = [
    {
      key: 'fullName',
      title: t('Pages.ViewKeyRiskIndicator.user'),
      editable: false,
      placeholder: t(''),
      render: (request) => `${request.userFirstName} ${request.userLastName}`,
    },
    {
      dataIndex: 'dateCreated',
      title: t('Pages.ViewKeyRiskIndicator.dateCreated'),
      editable: false,
      render: (value) => {
        return formatDate(value);
      },
      placeholder: t(''),
    },
    {
      dataIndex:  'description',
      title: t('Pages.ViewKeyRiskIndicator.description'),
      editable: false,
      placeholder: t(''),
    },
    {
      dataIndex: 'dateOfOccurrence',
      title: t('Pages.ViewKeyRiskIndicator.dateOfOccurrence'),
      editable: false,
      render: (value) => {
        return formatDate(value);
      },
      placeholder: t(''),
    },
  ];

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteKeyRiskOccurrence'),
        text: t('question.delete', {
          entity: t('Pages.ViewKeyRiskIndicator.riskOccurrence'),
        }),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteKeyRiskOccurrence(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('Pages.messages.deleteSuccess2', {
                  entity: t('Pages.common.keyRiskIndicatorOccurrence'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError', {
                entity: t('Pages.common.keyRiskIndicatorOccurrence'),
              }),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const actionsOpenModal = {
    editTooltip: 'Pages.KeyRiskIndicators.editKeyRiskIndicator',
    deleteTooltip: 'Pages.KeyRiskIndicators.deleteKeyRiskIndicator',
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateTable, setUpdateTable] = useState(false);
  const [tableRowId, setTableRowId] = useState('');

  const closeModal = () => {
    setIsModalOpen(false);
    setUpdateTable(false);
  };

  const editKeyRiskOccurrence = (id) => {
    setTableRowId(id);
    setIsModalOpen(true);
  };

  const edit = () => {
    window.location = window.location.href + '/edit';
  };

  const back = () => {
    props.history.goBack();
  };

  return (
    <div className="administration-template content">
      <Tabs defaultActiveKey="1" tabBarStyle={{color: '#37393c'}}>
        <TabPane
          tab={t('Pages.ViewKeyRiskIndicator.tab1').toUpperCase()}
          key="1"
        >
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {userRiskSector || userSuperAdmin ? (
                <div className="container-fluid controls d-flex align-items-center justify-content-end">
                  <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                      {!isEditing ? (
                        <div className="d-flex">
                          <button
                            className="primary-btn mr-3"
                            onClick={(event) => {
                              event.preventDefault();
                              edit();
                            }}
                          >
                            {t('common.edit')}
                          </button>

                          <Dropdown
                            buttonClass="options-btn"
                            trigger={<OptionsImg />}
                            children={
                              <span id="dropdown">
                                <li
                                  onClick={(e) => {
                                    e.preventDefault();
                                    goToAdd();
                                  }}
                                >
                                  {t('common.copy')}
                                </li>
                                <li
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onDeleteKeyRisk();
                                  }}
                                >
                                  {t('common.delete')}
                                </li>
                              </span>
                            }
                          ></Dropdown>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="container-fluid pt-4">
                <div className="row" key={isEditing}>
                  <div className="col-md-4 col-xl-3">
                    <div className="title mb-3">
                      {t('Pages.AddKeyRiskIndicator.processesAndSubprocesses')}
                    </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="process">
                        {t('Pages.AddKeyRiskIndicator.processes')}
                      </label>
                      <SelectInfinite
                        api="processes"
                        name="process"
                        key={keyRisk['process']}
                        selected={
                          keyRisk.process !== undefined ? keyRisk.process : ''
                        }
                        placeholder={t('litigation.placeholder.process')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={!isEditing}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="subprocess">
                        {t('Pages.AddKeyRiskIndicator.subprocesses')}
                      </label>
                      {/* <SelectList
                        name="subprocess"
                        key={watchProcess}
                        selected={
                          keyRisk.subprocess !== undefined
                            ? keyRisk.subprocess
                            : ''
                        }
                        isDisabled={disableSubprocess}
                        placeholder={t('common.select')}
                        options={subProcesses}
                      /> */}
                      <SelectInfinite
                        api={
                          watchProcess?.value !== undefined
                            ? `/subprocesses?processId.equals=${watchProcess?.value}`
                            : `/subprocesses?processId.equals=1`
                        }
                        name="subprocess"
                        placeholder={t('common.select')}
                        key={watchProcess}
                        className="select"
                        defaultValue={
                          keyRisk.subprocess !== undefined
                            ? keyRisk.subprocess
                            : ''
                        }
                        isDisabled={disableSubprocess}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label
                        className="label"
                        htmlFor="subprocessDescriptionMne"
                      >
                        {t('Pages.AddKeyRiskIndicator.subprocessesDescMne')}
                      </label>
                      <TextArea
                        name="subprocessDescriptionMne"
                        defaultValue={keyRisk['subprocessDescriptionMne']}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label
                        className="label"
                        htmlFor="subprocessDescriptionEn"
                      >
                        {t('Pages.AddKeyRiskIndicator.subprocessesDescEn')}
                      </label>
                      <TextArea
                        name="subprocessDescriptionEn"
                        defaultValue={keyRisk['subprocessDescriptionEn']}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="title mb-3">
                      {t('Pages.AddKeyRiskIndicator.indicators')}
                    </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="riskIndicatorNameMne">
                        {t('Pages.AddKeyRiskIndicator.keyRiskNameMne')}
                      </label>
                      <InputText
                        name="riskIndicatorNameMne"
                        disabled={!isEditing}
                        id="riskIndicatorNameMne"
                        defaultValue={keyRisk['riskIndicatorNameMne']}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label className="label" htmlFor="riskIndicatorNameEn">
                        {t('Pages.AddKeyRiskIndicator.keyRiskNameEn')}
                      </label>
                      <InputText
                        name="riskIndicatorNameEn"
                        disabled={!isEditing}
                        defaultValue={keyRisk['riskIndicatorNameEn']}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-4 col-xl-3">
                    <div className="title mb-3">
                      {t('Pages.AddKeyRiskIndicator.escalation')}
                    </div>
                    <div className="row mb-4 d-flex flex-md-column flex-lg-row">
                      <div className="col-md-12 col-lg-6">
                        <label className="label" htmlFor="escalationPointValue">
                          {t('Pages.AddKeyRiskIndicator.escalationPointValue')}
                        </label>
                        <InputText
                          name="escalationPointValue"
                          disabled={!isEditing}
                          type="number"
                          defaultValue={keyRisk['minValue']}
                          className="form-control"
                        />
                      </div>
                      <div className="col-md-12 col-lg-6">
                        <label className="label" htmlFor="period">
                          {t('Pages.AddKeyRiskIndicator.escalationPointPeriod')}
                        </label>
                        <SelectList
                          name="period"
                          options={periods}
                          key={keyRisk['indicatorPeriod']}
                          selected={keyRisk['indicatorPeriod']}
                          isDisabled={!isEditing}
                          placeholder={t('common.select')}
                        />
                      </div>
                    </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="escalationDescription">
                        {t('Pages.AddKeyRiskIndicator.escalationPointDesc')}
                      </label>
                      <TextArea
                        name="escalationDescription"
                        defaultValue={keyRisk['description']}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <div className="title mb-3">
                        {t('Pages.AddKeyRiskIndicator.organization')}
                      </div>
                      <label className="label" htmlFor="department">
                        {t('Pages.AddKeyRiskIndicator.department')}
                      </label>

                      <SelectInfinite
                        api="departments"
                        name="department"
                        placeholder={t('common.select')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        defaultValue={keyRisk['department']}
                        key={keyRisk['department']}
                        isDisabled={!isEditing}
                      />
                    </div>
                    <div className="title mb-3">
                      {t('Pages.AddKeyRiskIndicator.risk')}
                    </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="riskDescriptionMne">
                        {t('Pages.AddKeyRiskIndicator.riskDescMne')}
                      </label>
                      <TextArea
                        name="riskDescriptionMne"
                        defaultValue={keyRisk['riskDescription']}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="form-group">
                      <label className="label" htmlFor="riskDescriptionEn">
                        {t('Pages.AddKeyRiskIndicator.riskDescEn')}
                      </label>
                      <TextArea
                        name="riskDescriptionEn"
                        defaultValue={keyRisk['riskDescriptionEn']}
                        disabled={!isEditing}
                      />
                    </div>
                  </div>

                  <div className="col-md-4 col-xl-3">
                    <div className="title mb-3">
                      {t('Pages.AddKeyRiskIndicator.measures')}
                    </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="measuresDescriptionMne">
                        {t('Pages.AddKeyRiskIndicator.measuresDescMne')}
                      </label>
                      <TextArea
                        name="measuresDescriptionMne"
                        defaultValue={keyRisk['measuresDescription']}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="measuresDescriptionEn">
                        {t('Pages.AddKeyRiskIndicator.measuresDescEn')}
                      </label>
                      <TextArea
                        name="measuresDescriptionEn"
                        defaultValue={keyRisk['measuresDescriptionEn']}
                        disabled={!isEditing}
                      />
                    </div>
                    <div className="title mb-3">
                      {t('Pages.AddKeyRiskIndicator.year')}
                    </div>
                    <div className="form-group d-flex flex-column">
                      <label className="label" htmlFor="year">
                        {t('Pages.AddKeyRiskIndicator.year')}
                      </label>
                      <InputYear
                        name="year"
                        defaultValue={keyRisk['year']}
                        key={keyRisk['year']}
                        disabled={!isEditing}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {isEditing ? (
                <div className="container-fluid mt-4 footer">
                  <div className="row">
                    <div className="col-12 pt-4 pb-4 d-flex justify-content-end footer">
                      <button
                        className="secondary-btn"
                        onClick={(event) => {
                          event.preventDefault();
                          back();
                        }}
                      >
                        {t('common.cancel')}
                      </button>
                      <button type="submit" className="primary-btn">
                        {t('common.save')}
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
            </form>
          </FormProvider>
        </TabPane>
        <TabPane
          tab={t('Pages.ViewKeyRiskIndicator.tab2').toUpperCase()}
          key="2"
        >
          {userSuperAdmin ||
          departmentUserInCharge ||
          departmentUserResponsible ? (
            <div className="container-fluid controls d-flex align-items-center justify-content-end">
              <div className="row">
                <div className="col-12 d-flex justify-content-end">
                  <div>
                    <button
                      className="primary-btn pl-4 pr-4"
                      onClick={(event) => {
                        event.preventDefault();
                        setIsModalOpen(true);
                        setTableRowId('');
                      }}
                    >
                      {t('common.add')}
                    </button>
                    <OccurrenceModal
                      key={isModalOpen}
                      keyId={props.match.params.id}
                      tableRowId={tableRowId}
                      title={
                        tableRowId
                          ? t('Pages.ViewKeyRiskIndicator.edit')
                          : t('Pages.ViewKeyRiskIndicator.add')
                      }
                      isOpen={isModalOpen}
                      isClosed={closeModal}
                      escPressed={() => {
                        closeModal();
                      }}
                      updateTable={() => {
                        setUpdateTable(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <CustomTable
            api={'key-indicator-occurs'}
            query={`${props.match.params.id}`}
            queryParamName="keyIndicatorId.equals"
            columns={columns}
            actionsOpenModal={actionsOpenModal}
            onColumnEdit={editKeyRiskOccurrence}
            updateTable={updateTable}
            key={updateTable}
            methods={{onDelete}}
            actionsWidth={'100px'}
            roles={{
              userSuperAdmin: userSuperAdmin,
              userRiskSector: userRiskSector,
              userInCharge: departmentUserInCharge,
              userResponsible: departmentUserResponsible,
            }}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};
export default ViewKeyRiskIndicator;
